import React from "react";
import { Header } from "../components/Header/index.tsx";
import { HelmetProvider } from "react-helmet-async";
import { Seo } from "../components/Seo/index.tsx";
import { Contact } from "../components/Contact/index.tsx";
import { Footer } from "../components/Footer/index.tsx";
import { Hero } from "../components/Hero/index.tsx";
import { Features } from "../components/Features/index.tsx";
import { Industries } from "../components/Industries/index.tsx";
import { HowItWorks } from "../components/HowItWorks/index.tsx";
import { Devices } from "../components/Devices/index.tsx";
import "./home.css";

export default function HomePage() {
  return (
    <HelmetProvider>
      <Seo />
      <Header />
      <main>
        <Hero />
        <Features />
        <Industries />
        <HowItWorks />
        <Devices />
        <Contact />
      </main>
      <Footer />
    </HelmetProvider>
  );
}
